import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class EncryptionServiceService {

  private readonly secretKey = 'SECRET_1SECRET_2SECRET_3';

  createEncryptedRequest(data: any) {
    const json = JSON.stringify(data);

    const tokenKey = 'Key1234';

    const encData = CryptoJS.AES.encrypt(json, tokenKey).toString();

    const encryptedTokenKey = CryptoJS.AES.encrypt(
      tokenKey,
      this.secretKey
    ).toString();

    return {
      EncData: encData,
      TokenKey: encryptedTokenKey
    };
  }

  createEncryptedFormDataRequest(data: any, fileKey: string = 'PDFFiles'): FormData {
    const formData = new FormData();

    const files =
      data?.PDFFiles ||
      data?.pdfFiles ||
      data?.files ||
      data?.Files ||
      [];

    const plainData = { ...data };

    delete plainData.PDFFiles;
    delete plainData.pdfFiles;
    delete plainData.files;
    delete plainData.Files;

    const encryptedBody = this.createEncryptedRequest(plainData);

    formData.append('encData', encryptedBody.EncData);
    formData.append('tokenKey', encryptedBody.TokenKey);

    if (Array.isArray(files)) {
      files.forEach((file: File) => {
        formData.append(fileKey, file, file.name);
      });
    }

    return formData;
  }

  decryptResponse(response: any): any {
    const encData = response?.encData || response?.EncData;
    const tokenKey = response?.tokenKey || response?.TokenKey;

    if (!encData || !tokenKey) {
      return response;
    }

    const decryptedKey = CryptoJS.AES.decrypt(
      tokenKey,
      this.secretKey
    ).toString(CryptoJS.enc.Utf8);

    const decryptedData = CryptoJS.AES.decrypt(
      encData,
      decryptedKey
    ).toString(CryptoJS.enc.Utf8);

    try {
      return JSON.parse(decryptedData);
    } catch {
      return decryptedData;
    }
  }
}